import React from 'react';
import useScreenSize from '../../../hooks/useScreenSize';
import {
  Header,
  HeaderLeftAction,
  HeaderTitle,
  HeaderTitleWrapper,
  HeaderRightAction,
  HeaderBottom,
  HeaderCustomLeftAction
} from './styled';
import { useHeaderActions } from './useHeaderActions';
import { HeaderPosition, BackButtonIconEnum, PageHeaderProps } from './types';

export const PageHeader: React.FC<PageHeaderProps> = ({
  id,
  titleCypress,
  title,
  titleIcon,
  height = 60,
  icon,
  backButtonCypress,
  rightBlock,
  bottomBlock,
  onClick,
  showHeaderBorder = true,
  closeButtonAlign = 'left',
  headerPosition = HeaderPosition.Sticky,
  headerTag,
  styles,
  leftBlock
}) => {
  const { isSmall } = useScreenSize();

  const { customLeftAction, customRightAction } = useHeaderActions(
    icon || BackButtonIconEnum.Back,
    onClick,
    backButtonCypress
  );

  return (
    <>
      <Header
        id={id}
        height={height}
        $showHeaderBorder={showHeaderBorder}
        $headerPosition={headerPosition}
        $styles={styles}
      >
        {leftBlock && (
          <HeaderCustomLeftAction>{leftBlock}</HeaderCustomLeftAction>
        )}

        <HeaderLeftAction $closeButtonAlign={closeButtonAlign}>
          {customLeftAction}
        </HeaderLeftAction>

        {title && (
          <HeaderTitleWrapper>
            {titleIcon}
            <HeaderTitle
              data-cy={titleCypress}
              tag={headerTag || (isSmall ? 'h3' : 'h4_new')}
            >
              {title}
            </HeaderTitle>
          </HeaderTitleWrapper>
        )}

        {rightBlock && <HeaderRightAction>{rightBlock}</HeaderRightAction>}
        {customRightAction && customRightAction}
      </Header>
      {bottomBlock && <HeaderBottom>{bottomBlock}</HeaderBottom>}
    </>
  );
};
